import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

// @TODO move this to polyifils.ts
declare var $: any;

@Directive({
    selector: '[appUITooltip]',
    standalone: false
})
export class TooltipDirective implements AfterViewInit {
  @Input() ttitle: string;
  @Input() placement: string;
  @Input() trigger = 'click';
  @Input() appUITooltip = true;
  @Input() hideTooltipAfterMs = 600;

  private tooltipEl: any;

  @Input() set dynamicTitleParameter (param: string|number) {
    setTimeout(() => {
      this.setTooltipTitle([param, this.ttitle].join(' '));
    }, this.hideTooltipAfterMs / 3);
  }

  @Input() set dynamicTitle (title: string) {
    setTimeout(() => {
      const titleIsChanged = !!this.getTooltipTitle()?.length;
      this.setTooltipTitle(title);
      this.toggle(titleIsChanged);
    });
  }

  constructor(private readonly element: ElementRef) { }

  ngAfterViewInit() {
    setTimeout(() => {
      if (!this.appUITooltip) {
        return;
      }

      this.tooltipEl = $(this.element.nativeElement);
      this.tooltipEl.tooltip({
        title: this.ttitle,
        placement: this.placement,
        trigger: this.trigger
      });
    }, 0);
  }

  hide() {
    setTimeout(() => {
      this.hideTooltip();
    }, this.hideTooltipAfterMs);
  }

  show() {
    this.showTooltip();
    this.hide();
  }

  toggle(showTooltipAfterTitleChange: boolean) {
    this.hideTooltip();

    if (showTooltipAfterTitleChange) {
      setTimeout(() => {
        this.showTooltip();
      }, this.hideTooltipAfterMs / 3);
    }
  }

  private hideTooltip() {
    this.tooltipEl?.tooltip('hide');
  }

  private showTooltip() {
    this.tooltipEl?.tooltip('show');
  }

  private setTooltipTitle(title: string) {
    this.tooltipEl?.attr('data-original-title', title);
  }

  private getTooltipTitle(): string {
    return this.tooltipEl?.attr('data-original-title');
  }
}
